import { z } from 'zod';

export const loginSchema = z.object({
  email: z.email().max(254),
  password: z.string().min(1).max(256),
});

export type LoginDto = z.infer<typeof loginSchema>;

/** Escopo do token: `TROCA_SENHA` so abre GET /me e POST /auth/trocar-senha (PERMISSOES.md 6). */
export const escopoToken = z.enum(['APP', 'TROCA_SENHA']);
export type EscopoToken = z.infer<typeof escopoToken>;

export interface LoginResponse {
  accessToken: string;
  tokenType: 'Bearer';
  expiresIn: number;
  escopo: EscopoToken;
  /** true = senha temporaria: o web leva o usuario direto para a troca. */
  deveTrocarSenha: boolean;
}

/** Politica minima de senha (PERMISSOES.md 9.2 item 11): 12 caracteres ou mais. A API e quem confere; o web mostra a mesma regra. */
export const SENHA_TAMANHO_MINIMO = 12;
export const SENHA_TAMANHO_MAXIMO = 128;

export const novaSenhaSchema = z
  .string()
  .min(SENHA_TAMANHO_MINIMO, `A nova senha precisa de pelo menos ${SENHA_TAMANHO_MINIMO} caracteres`)
  .max(SENHA_TAMANHO_MAXIMO, `A nova senha tem no maximo ${SENHA_TAMANHO_MAXIMO} caracteres`)
  .refine((s) => s.trim().length > 0 && new Set(s).size >= 4, 'Use uma senha menos repetitiva');

/** POST /auth/trocar-senha. A nova senha precisa ser diferente da atual (e da temporaria, no primeiro login). */
export const trocarSenhaSchema = z
  .object({
    senhaAtual: z.string().min(1, 'Informe a senha atual').max(256),
    novaSenha: novaSenhaSchema,
  })
  .refine((v) => v.senhaAtual !== v.novaSenha, { path: ['novaSenha'], message: 'A nova senha deve ser diferente da atual' });
export type TrocarSenhaDto = z.infer<typeof trocarSenhaSchema>;

/** Formulario da tela (confirmacao so existe no front; a API recebe `trocarSenhaSchema`). */
export const trocarSenhaFormSchema = z
  .object({
    senhaAtual: z.string().min(1, 'Informe a senha atual').max(256),
    novaSenha: novaSenhaSchema,
    confirmacao: z.string().min(1, 'Repita a nova senha'),
  })
  .refine((v) => v.senhaAtual !== v.novaSenha, { path: ['novaSenha'], message: 'A nova senha deve ser diferente da atual' })
  .refine((v) => v.novaSenha === v.confirmacao, { path: ['confirmacao'], message: 'A confirmação não confere com a nova senha' });
export type TrocarSenhaFormValores = z.infer<typeof trocarSenhaFormSchema>;
